var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-image-upload" },
    [
      _vm.template.show
        ? _c("div", { staticClass: "file-template" }, [
            _vm._v(" " + _vm._s(_vm.template.desc) + " "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.template.link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [_vm._v(" " + _vm._s(_vm.template.title) + " ")]
            ),
          ])
        : _vm._e(),
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          attrs: {
            "on-success": _vm.onSuccess,
            "on-remove": _vm.onRemove,
            "on-error": _vm.onError,
            action: _vm.domain + "/upload",
            headers: _vm.headers,
            "list-type": "text",
            "before-upload": _vm.beforeUpload,
            loading: _vm.loading,
            "file-list": _vm.fileList,
            accept: _vm.accept,
            disabled: _vm.disabled,
            "with-credentials": "",
            limit: _vm.limit,
            multiple: _vm.multiple,
            "on-exceed": _vm.onExceed,
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.loading,
                disabled: _vm.disabled,
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.upload.uploadField")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }